import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { AdminOrderItemComponentResponse } from './admin-order-item-component.response';
import { AdminOrderShipmentComponentGroupType } from '../../enums/admin-order-shipment-component-group-type';

@jsonObject
export class AdminOrderShipmentComponentGroupResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly type!: AdminOrderShipmentComponentGroupType;

  @jsonArrayMember(AdminOrderItemComponentResponse)
  public readonly components!: AdminOrderItemComponentResponse[];
}
